import { GLServiceBase, ServiceRoute, getServiceMethodKey } from "@/commonui/services";
import { PhraseModel } from "@/models/phrase-list-model";
import { HttpMethod, ServerExceptionCode } from "commonui";

class PhraseListServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/phrase" };
	deletePharseUrl = "deletePhrase";

	// errMsgs = (() => {
	// 	const result = {};
	// 	result[getServiceMethodKey(this, HttpMethod.Delete, ServerExceptionCode.PhraseIsLemmaException, `${this.serviceRoute.prefix}/${this.deletePharseUrl}`)] =
	// 		"Phrase is lemma exception";

	// 	return result;
	// })();

	getPhraseList(): Promise<PhraseModel[]> {
		return this.get("getPhraseList");
	}

	deletePhrase(pharseId: number): Promise<boolean> {
		return this.delete(this.deletePharseUrl, { phraseId: pharseId });
	}

	saveUpdatePhrase(data: PhraseModel): Promise<boolean> {
		return this.request.post(this.url("saveUpdatePhrase"), data);
	}
}

export const PhraseListService = new PhraseListServiceClass();
